module.exports = __webpack_public_path__ + "static/media/family-suite-img3.7f22e2d5.jpg";